import { observer } from 'mobx-react';
import { fromArrayMaybe } from 'nonempty-list';
import LearningCollectionEditStore from '../../Edit/Store';
import {
  AddingLearningDesign,
  Building,
  EditFormSubmissionError,
  LearningCollectionEditFormResource,
} from '../../Edit/Store/Types';
import ActiveLearningDesignExperiences from './ActiveLearningDesignExperiences';
import NewSectionLink from './NewSectionLink';
import SectionPlaceholder from './SectionPlaceholder';

interface Props {
  store: LearningCollectionEditStore;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
  state: Building | EditFormSubmissionError | AddingLearningDesign;
}

function LearningDesignExperiences({ store, state, learningCollectionEditFormResource }: Props) {
  return fromArrayMaybe(store.sections)
    .map((sectionsList) => (
      <>
        <ActiveLearningDesignExperiences
          store={store}
          sections={sectionsList}
          learningCollectionEditFormResource={learningCollectionEditFormResource}
        />
        <NewSectionLink store={store} state={state} />
      </>
    ))
    .getOrElse(() => (
      <>
        <NewSectionLink store={store} state={state} />
        <SectionPlaceholder />
      </>
    ));
}

export default observer(LearningDesignExperiences);
